module.exports = __webpack_public_path__ + "static/media/pdf.e57dc3fa.png";